import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleProductData } from "../../slice/productSlice";
import ProductDetailView from "../../components/product/ProductDetailView";
import { getVendorIdFromToken } from "../../helpers/utils";

const SingleProduct = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    singleProductState: { data: product, loading, error },
  } = useSelector((state) => state.productLists);

  useEffect(() => {
    const vendorId = getVendorIdFromToken();
    if (!vendorId) {
      navigate("/auth");
      return;
    }
    dispatch(fetchSingleProductData({ productId: id, vendorId }));
  }, [id, dispatch, navigate]);

  return <ProductDetailView product={product} loading={loading} error={error} />;
};

export default SingleProduct;
